// extracted by mini-css-extract-plugin
module.exports = {"container":"_72555be","big":"_a82bd43","small":"_fff360f"};